module.exports = __webpack_public_path__ + "img/qianchuan.7e629240.png";